export default {
  cart: [],
  cartBranch: [],
  cartOthers: [],
  totalCartBranch: 0,
  totalCartOthers: 0,
  stock: []
}
